import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import AdminSettingsService from './../../../services/adminsettings.service';
import {Validator} from 'vee-validate';
import CargoAllocationService from '../../../../cargoallocation/services/cargoallocation.service'
import MasterService from '../../../../masterdata/services/masterdata.service'
import ClientService from '../../../../clientmanagement/services/clientmanagement.service'
import BookingService from '../../../../cargobooking/services/cargobooking.service'
export default {
  name: 'changedefaulthub',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  props: [],
  data: function() {
    return {
      isLoading:false,
      adminsettingdata:[],
      printstickeroptions:"",
      hubaccess:[],
      hubaccessObjArray:[],
      currentHub:'',
      hubid:'',
      hubid1:'',
      Clientlist:[],
      ClientBusinessAccountlist:[],
	    ClientOTPlist:[],
      selectedClients:[],
      selectedClientsForClientRefNo:[],
      selectedClientsForRefNo:[],
      selectedClientsForDisabledWt:[],
      RolesList:[],
      roleId:'',
      rolename:'',
      autofetchdatalimit:"",
	    mpsPrintDisabledClients:"",
	    OTPBasedDelivery:"",
	    openpickupdelivery:"",
  	  ClientReferenceNolist:"",
  	  ReferenceNolist:"",
  	  ClientsForDisabledWt:"",
      ClientsForDisableDWS:"",
      ClientsForEnabledMPSAllocation:"",
      ClientsForMPSLevelWeightCapture:"",
  	  clientlist:[],
      ShowClientDetails:false,
	    clinetnamelist:"",
    	ShowAwbCopy:false,
    	ShowMpsCopy:false,
    	ShowAwbCopyDetails:false,
    	printcopy:'',
    	awblrcopy:'',
    	mpssticker:'',
    	mpsstickerprint:'',
    	bookingfield:'',
    	bookingfieldlist1:[
    		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Pickup Location', value:'PickupLocation',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
        { key:'Pickup Item Count', value:'PickupItemCount',disable:0},
    	],
    	bookingfieldlist2:[
    		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Pickup Location', value:'PickupLocation',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
        { key:'Pickup Item Count', value:'PickupItemCount',disable:0},
    	],
    	bookingfieldlist3:[
    		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Pickup Location', value:'PickupLocation',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
		    { key:'Invoice Number', value:'InvoiceNumber',disable:0},
		    { key:'EWB Number', value:'ebn',disable:0},
		    { key:'Consignee Address', value:'ConsigneeAddress',disable:0},
        { key:'Pickup Item Count', value:'PickupItemCount',disable:0},
    	],
    	mpsfieldlist1:[
    		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
		    { key:'Invoice Number', value:'InvoiceNumber',disable:0},
		    { key:'EWB Number', value:'ebn',disable:0},
		    { key:'Carton No', value:'cartonno',disable:0},
		    { key:'Carton No + Box Reference No.', value:'cartonnoboxrefno',disable:0},
    	],
    	mpsfieldlist2:[
    		{ key:'Reference Number', value:'referenceno',disable:0},
        { key:'Consignee Code', value:'ConsigneeCode',disable:0},
        { key:'Company Name (Consignee)', value:'consigneename',disable:0},
        { key:'Consignee POC', value:'ConsigneePOC',disable:0},
        { key:'Client Reference Number', value:'ClientReferenceNo',disable:0},
		    { key:'Invoice Number', value:'InvoiceNumber',disable:0},
        { key:'EWB Number', value:'ebn',disable:0},
		    { key:'Carton No', value:'cartonno',disable:0},
		    { key:'Carton No + Box Reference No.', value:'cartonnowithboxrefno',disable:0},
    	],
    	awblrcopydata:{},
    	mpsstickerdata:{},
    	selectedAwbCopy:[null,null,null],
    	selectedMpsCopy:[null,null],
    	bookingfield1:'',
    	bookingfield2:'',
    	bookingfield3:'',
    	bookinglabel1:'',
    	bookinglabel2:'',
    	bookinglabel3:'',
    	bookingmpslabel1:'',
    	bookingmpslabel2:'',
    	bookingmpsfield1:'',
    	bookingmpsfield2:'',
    	bookingmpsfieldlist1:'',
    	bookingmpsfieldlist2:'',
      ConsigneeCodeOnMps:"",
    	clientdata:{},
    	RelianceSecondaryClient:"",
    	ProofOfPickup:"",
      ShowGlobalPickup:false,
      globalpickuppincodedataArray:[],
      globalpickup:'',
      pincode:[],
      finalpincode:[],
      ShowClientDetailsforglobalpickup:false,
      GlobalPickupClientPincodeData:{},
      disablesave:false,
  	  dwshub:'',
      ShowGlobalDelivery:false,
      globaldeliverypincode:[],
      enableverification: "",
      enabledimensionvisibilitylrcopy: "",
      blockclient: false,
      blockpickup : 0,
      blockdelivery : 0,
      blockclientreason:"",
      blockclientcode : {},
      globaldeliveryflag:'',
      globaldropoffpincode:[],
      finalGlobalDropoffPinode:[],
      initialDropPincodeoffEmpty:true,
      ShowGlobalDropoff:false,
      initialDataEmpty:true,
      clientBusinessAccountId:"",
      clientId:"",
      showSaveButton: false,
      DisabledProofOfDelivery : '',
      ShowRestrictedPincodes : false,
      deliveryPincode : "",
      pickupPincode : "",
      selectAllPickupPincodes : false,
      selectAllDeliveryPincodes : false,
      pickupPincodedataArray : [],
      deliveryPincodedataArray : [],
      disablepod : false,
      isreuploadpodrequired : false,
      consigneeList : [],
      selectedConsignee : null,
      PODPincode : null,
      isLoadingPod : false,
      selectAllConsignee : false,
      podConfig : []
    }
  },
  computed: {
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub = userdetail.hubID[0];
    await Promise.all([this.loadAllHubAccessList(),this.getCompanyShortName(),this.getRoleList()]);
    await this.getAdminSettings();
  },
  methods: {
    async loadAllHubAccessList() {
      try {
        let InputPayload = {};
        this.isLoading = true;
        let response = await MasterService.GetHublist(InputPayload);
        if(response.data.code===200){
          this.hubaccess = response.data.data.data;
          for (var i = 0; i < this.hubaccess.length; i++) {
            this.hubaccessObjArray.push({
              hubid: this.hubaccess[i].HubID,
              hubname: this.hubaccess[i].HubName
            })
          }
        let getcurrenthubobj = this.hubaccess.find(hubs => hubs.HubID == this.currentHub );
        this.hubid = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        this.hubid1 = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
		    this.dwshub = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        let payload ={
          username: this.useremail,
          hubid:this.currentHub
        }
        let scandata = await AdminSettingsService.getAdminSettings(payload);
        }
        else {
          this.$alertify.error(response.data.message);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getAdminSettings(){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail
        }
        let result = await AdminSettingsService.getAdminSettings(inputPayload);
        this.adminsettingdata = result.data.data.settings;
        let tempPrintDisabled = this.getValueByKeyName('PRINTDISABLED');
        this.Clientlist.forEach(item => {
          if(tempPrintDisabled.includes(item.clientId)){
            this.selectedClients.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });

        //Client Refetence no config clients
        let tempClientReferenceNoConfigClients = this.getValueByKeyName('CLIENTREFERENCENO');
        this.ClientBusinessAccountlist.forEach(item => {
          if(tempClientReferenceNoConfigClients.includes(item.clientId)){
            this.selectedClientsForClientRefNo.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });

        //reference no cofig clients
        let tempReferenceNoConfigClients = this.getValueByKeyName('REFERENCENO');
        this.ClientBusinessAccountlist.forEach(item => {
          if(tempReferenceNoConfigClients.includes(item.clientId)){
            this.selectedClientsForRefNo.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });

        //weight disabled cofig clients
        let tempWtDisabledConfigClients = this.getValueByKeyName('DISABLEDWEIGHTDIMENSIONS');
        this.ClientBusinessAccountlist.forEach(item => {
          if(tempWtDisabledConfigClients.includes(item.clientId)){
            this.selectedClientsForDisabledWt.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });
        let temproles = this.getValueByKeyName('PRQCONFIG');
        this.roleId=[];
        this.RolesList.forEach(item=>{
          if(temproles.includes(item.rolename)){
            this.roleId.push({
              'rolename': item.rolename
            })
          }
        })
        this.printstickeroptions = JSON.stringify(this.getValueByKeyName('PRINTTYPELIST'));
        this.autofetchdatalimit = this.getValueByKeyName('FETCHDATALIMIT');
        this.globaldeliveryflag = this.getValueByKeyName('GLOBALDELIVERYFLAG')[0];
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    getHubName(hubid) {
      for (var i = 0; i < this.hubaccessObjArray.length; i++) {
        if (this.hubaccessObjArray[i].hubid == hubid) {
          return this.hubaccessObjArray[i].hubname;
        }
      }
    },
    getValueByKeyName(key) {
      for (var i = 0; i < this.adminsettingdata.length; i++) {
        if (this.adminsettingdata[i].key == key) {
          return this.adminsettingdata[i].value;
        }
      }
    },
    async getCompanyShortName(){
      try {
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload)
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
            'clientId': CompanyShortList[i].clientid,
            'clientName': CompanyShortList[i].clientshortname,
          });

          this.ClientBusinessAccountlist.push({
            'clientId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          });
		  this.ClientOTPlist.push({
			     'clientId':CompanyShortList[i].clientid,
            'clientBusinessAccountId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          });
        }
      } catch(err){
        console.log(err);
      }
    },
    async onConsigneeSearch(){
      this.$validator.validateAll("podconfig").then(async (result) => {
        if (result) {
         this.getConsigneeList()
        }
      }).catch((err) => {
        console.log('errors exist',err);
        return false;
      });
     },
    async getConsigneeList(){
      try {
        let InputPayload = {
          clientid: this.selectedClients.clientId,
          pincode:  this.PODPincode,
          clientbusinessaccountid:  this.selectedClients.clientBusinessAccountId,
        };
        var consigneeList = [];
        this.consigneeList = [];
        this.selectedConsignee = null;
        this.isLoadingPod = true
        let result = await BookingService.getConsigneeLocationList(InputPayload)
        this.isLoadingPod = false
        consigneeList = result.data.data;
        for (var i = 0; i < consigneeList.length; i++) {
          this.consigneeList.push({
            consigneecode : consigneeList[i].consigneecode
          })
        }
      } catch(err){
        this.isLoadingPod = false
        console.log(err);
      }
    },
    selectAllConsigneeFunction(){
      this.selectedConsignee = null;
    },
    addConsigneerow(){
      if (this.PODPincode.length == 6 && (this.selectedConsignee || this.selectAllConsignee)) {
        let consigneearr = [];
        let alreadyExistsFlag = false;
        if (this.selectedConsignee && this.selectedConsignee.length > 0) {
          this.selectedConsignee.forEach(element => {
            consigneearr.push(element.consigneecode)
          });
        }
        this.podConfig.forEach(obj => {
          if (obj.pincode === this.PODPincode) {
            if ( obj.allconsignee = 1 && !this.selectAllConsignee) {
                obj.allconsignee = 0
            }
            if (this.selectAllConsignee) {
              obj.allconsignee = 1
              obj.consigneecodes = []
            }else{
              let combinedSet = new Set([...obj.consigneecodes,...consigneearr]);
              obj.consigneecodes = Array.from(combinedSet);
            }
            alreadyExistsFlag = true
          }
        });
        if (!alreadyExistsFlag) {
          this.podConfig.push({
            pincode : this.PODPincode,
            consigneecodes : this.selectAllConsignee ? [] : consigneearr,
            allconsignee : this.selectAllConsignee ? 1 : 0
          })
        }
        this.PODPincode = null;
        this.selectedConsignee = null;
        this.selectAllConsignee = false;
        this.consigneeList = []
        this.$validator.reset()
        this.$alertify.success("Record added successfully")
      }else{
        this.$alertify.error("Please select pincode and consignee")
      }
    },
    removedSelectedRecord(index){
      this.podConfig.splice(index, 1);
    },
    async getRoleList(){
      try {
        this.isLoading = true;
        this.RolesList = [];
        let result = await MasterService.getRolesList();
        this.isLoading = false;
        if (result.data.code == 200) {
          result.data.data.rows.forEach(item=>{
              this.RolesList.push({
                'rolename':item.rolename
              });
          })
        }else {
          this.rolesList = [];
          this.$alert("Internal Server Error",'Admin Setting', "error");
        }
      }  catch(err){
        console.log(err);
      }
    },
    async saveClientSettings(){
      try {
        this.isLoading = true;
        if(this.selectedClients.clientId){
        let inputPayload = {
          username: this.useremail,
          }
        this.clientdata = {
          mpsprintdisabled: this.mpsPrintDisabledClients == true ? 1 :0,
          referenceno: this.ReferenceNolist == true ? 1 : 0,
          clientreferenceno: this.ClientReferenceNolist ? 1 : 0,
          clientdisabledwt : this.ClientsForDisabledWt ? 1 : 0,
          otpbaseddelivery: this.OTPBasedDelivery ? 1 : 0,
          openpickupdelivery: this.openpickupdelivery,
          consigneecodeonmpssticker : this.ConsigneeCodeOnMps ? 1 :0,
          realiancesecondaryclient : this.RelianceSecondaryClient ? 1 : 0,
          poprequired: this.ProofOfPickup ? 1 : 0,
          enableverificationflag: this.enableverification ? 1 : 0,
          enabledimensionvisibilitylrcopy: this.enabledimensionvisibilitylrcopy ? 1 : 0,
          clientdisabledws: this.ClientsForDisableDWS ? 1 : 0,
          clientenablempsallocation: this.ClientsForEnabledMPSAllocation ? 1 : 0,
          clientenablempslevelweightcapture: this.ClientsForMPSLevelWeightCapture ? 1 : 0,
          ispoddisabled:this.DisabledProofOfDelivery ? 1 : 0,
          isreuploadpodrequired:this.isreuploadpodrequired ? 1 : 0
        }
        if (this.isreuploadpodrequired) {
          if (this.podConfig.length == 0 && this.disablepod) {
            this.isLoading = false;
           this.$alert('Please enter atleast one pincode for Delayed POD Upload (Post Delivery)', "", "error");
           return false;
          }
          this.clientdata.poddisabledconfig = this.podConfig
        }
        if(this.awblrcopydata && Object.keys(this.awblrcopydata).length>0){
          this.clientdata.awbcopy = this.awblrcopydata
        }
        if(this.mpsstickerdata && Object.keys(this.mpsstickerdata).length>0){
          this.clientdata.mpscopy = this.mpsstickerdata
        }
        if(this.pincode && Object.keys(this.pincode).length>0){
          this.clientdata.pincode = this.pincode
        }
        if(this.globaldeliverypincode && Object.keys(this.globaldeliverypincode).length>0){
          this.clientdata.globaldeliverypincode = this.globaldeliverypincode
        }
        if(this.blockclientcode && Object.keys(this.blockclientcode).length>0){
          this.clientdata.blockclientcode = this.blockclientcode
        }
        if(this.globaldropoffpincode && Object.keys(this.globaldropoffpincode).length>0){
          this.clientdata.globaldropoffpincode = this.globaldropoffpincode
        }
        let clientid = this.selectedClients.clientId
        let clientBusinessAccountId = this.selectedClients.clientBusinessAccountId
        let clientName = this.selectedClients.clientName
        if (this.pickupPincode.length> 0 || this.deliveryPincode.length > 0 || this.selectAllDeliveryPincodes || this.selectAllPickupPincodes) {
          let restrictserviceability = {
            "pickuppincodes" : this.pickupPincode,
            "deliverypincodes" : this.deliveryPincode,
            "allpickuppincodes" : this.selectAllPickupPincodes ? 1 : 0,
            "alldeliverypincodes" : this.selectAllDeliveryPincodes ? 1 : 0,
            "ischecked": 1
          }
          this.clientdata.restrictserviceability = restrictserviceability;
        }
        inputPayload.clientData = this.clientdata
        inputPayload.clientId = clientid
        inputPayload.clientBusinessAccountId = clientBusinessAccountId
        let result = await AdminSettingsService.saveClientSettings(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, "", "success");
          await this.fecthClientDetails(this.clientId,this.clientBusinessAccountId);
        }else{
          this.$alert(result.data.message, "", "error");
        }
        }else{
        this.isLoading = false;
        this.$alertify.error("Please select client name")
        }
      } catch (error) {
         console.log(error);
             this.isLoading = false;
      }
      },
	 async onSelectClient (event) {
		if (event.clientId) {
		  this.resetAWBCopy()
		  this.resetMPSCopy()
      this.resetGlobalPickup('all')
      this.resetBlockClientCodeData()
      this.resetRestrictedPincodes()
      this.resetPodDisable()
      this.clientId=event.clientId;
      this.clientBusinessAccountId=event.clientBusinessAccountId
		  await this.fecthClientDetails(event.clientId,event.clientBusinessAccountId);
      this.showSaveButton=true
		}else{
		  this.$alert(result.data.message, "", "error");
		}
	  },
	  async fecthClientDetails(clientid,clientbusinessaccid){
		try {
			this.isLoading = true;
			let inputPayload = {}
			inputPayload.clientId = clientid
			inputPayload.clientBusinessAccountId = clientbusinessaccid
			let result = await AdminSettingsService.getClientSettings(inputPayload)
			this.isLoading = false;
      let openpickupdelivery = {
        Surface: 0,
        Air: 0
      }
			if (result.data.code == 200) {
				let clientSettingData  = result.data.data[0].configparam;
				this.mpsPrintDisabledClients = result.data.data[0].configparam.mpsprintdisabled == 1 ? true : false;
				this.ReferenceNolist = result.data.data[0].configparam.referenceno == 1 ? true : false;
				this.ClientReferenceNolist = result.data.data[0].configparam.clientreferenceno == 1 ? true : false;
				this.ClientsForDisabledWt = result.data.data[0].configparam.clientdisabledwt == 1 ? true : false;
        this.ClientsForDisableDWS = result.data.data[0].configparam.clientdisabledws == 1 ? true : false;
        this.ClientsForEnabledMPSAllocation = result.data.data[0].configparam.clientenablempsallocation == 1 ? true : false;
        this.ClientsForMPSLevelWeightCapture = result.data.data[0].configparam.clientenablempslevelweightcapture == 1 ? true : false;
        this.ProofOfDelivery = result.data.data[0].configparam.ispoddisabled == 1 ? true : false;
				this.OTPBasedDelivery = result.data.data[0].configparam.otpbaseddelivery == 1 ? true : false;
				this.openpickupdelivery = (result.data.data[0].configparam.openpickupdelivery)? result.data.data[0].configparam.openpickupdelivery:openpickupdelivery
        this.DisabledProofOfDelivery = result.data.data[0].configparam.ispoddisabled == 1 ? true : false;
        this.isreuploadpodrequired = result.data.data[0].configparam.isreuploadpodrequired == 1 ? true : false;
        if (result.data.data[0].configparam.isreuploadpodrequired == 1) {
          this.podConfig = result.data.data[0].configparam.poddisabledconfig ? result.data.data[0].configparam.poddisabledconfig : []
        }
				this.awblrcopy = false;
				if(clientSettingData.awbcopy){
					this.awblrcopy = result.data.data[0].configparam.awbcopy.ischecked!=0 ? true : false
				}
				if(this.awblrcopy){
				  this.awblrcopydata = clientSettingData.awbcopy
				  this.clientdata.awbcopy = clientSettingData.awbcopy
				  this.bookinglabel1 = clientSettingData.awbcopy.field1 != null ? clientSettingData.awbcopy.field1.label : "",
				  this.bookingfield1 = clientSettingData.awbcopy.field1 != null ? clientSettingData.awbcopy.field1.columnname : ""
				  if(clientSettingData.awbcopy.field1 != null){
					this.updateLRDropdown('field1',this.bookingfield1)
				  }
				  this.bookinglabel2 = clientSettingData.awbcopy.field2 != null ? clientSettingData.awbcopy.field2.label : "",
				  this.bookingfield2 = clientSettingData.awbcopy.field2 != null ? clientSettingData.awbcopy.field2.columnname : ""
				  if(clientSettingData.awbcopy.field2 != null){
					this.updateLRDropdown('field2',this.bookingfield2)
				  }
				  this.bookinglabel3 = clientSettingData.awbcopy.field3 != null ? clientSettingData.awbcopy.field3.label : "",
				  this.bookingfield3 = clientSettingData.awbcopy.field3 != null ? clientSettingData.awbcopy.field3.columnname : ""
				  if(clientSettingData.awbcopy.field3 != null){
					this.updateLRDropdown('field3',this.bookingfield3)
				  }
				}
				this.mpssticker = false;
				if(clientSettingData.mpscopy){
					this.mpssticker = result.data.data[0].configparam.mpscopy.ischecked!=0 ? true : false
				}
				if(this.mpssticker){
				  this.mpsstickerdata = clientSettingData.mpscopy
				  this.clientdata.mpscopy = clientSettingData.mpscopy
				  this.bookingmpslabel1 = clientSettingData.mpscopy.field1 != null ? clientSettingData.mpscopy.field1.label : "",
				  this.bookingmpsfield1 = clientSettingData.mpscopy.field1 != null ? clientSettingData.mpscopy.field1.columnname : ""
				  if(clientSettingData.mpscopy.field1 != null){
					this.updateMpsStickerDropdown('field1',this.bookingmpsfield1)
				  }
				  this.bookingmpslabel2 = clientSettingData.mpscopy.field2 != null ? clientSettingData.mpscopy.field2.label : "",
				  this.bookingmpsfield2 = clientSettingData.mpscopy.field2 != null ? clientSettingData.mpscopy.field2.columnname : ""
				  if(clientSettingData.mpscopy.field2 != null){
					this.updateMpsStickerDropdown('field2',this.bookingmpsfield2)
				  }
				}
				this.ConsigneeCodeOnMps = result.data.data[0].configparam.consigneecodeonmpssticker == 1 ? true : false
				this.RelianceSecondaryClient = result.data.data[0].configparam.realiancesecondaryclient == 1 ? true : false
				this.ProofOfPickup = result.data.data[0].configparam.poprequired == 1 ? true : false
        this.enableverification = result.data.data[0].configparam.enableverificationflag == 1 ? true : false
        this.enabledimensionvisibilitylrcopy = result.data.data[0].configparam.enabledimensionvisibilitylrcopy == 1 ? true : false
        if(clientSettingData.pincode)
        {
          this.globalpickup= (result.data.data[0].configparam.pincode).length>0 ? true : false
        }
        if(this.globalpickup){
				this.pincode= clientSettingData.pincode
        if(clientSettingData.pincode.length!=0){
          this.initialDataEmpty=false
        this.finalpincode= clientSettingData.pincode
        }
				}
        if(clientSettingData.globaldeliverypincode) {
          this.globaldelivery=false;
          if ((result.data.data[0].configparam.globaldeliverypincode).length>0) {
            this.globaldelivery=true
            this.globaldeliverypincode= clientSettingData.globaldeliverypincode
          }
        }
        if(clientSettingData.globaldropoffpincode){
          if ((result.data.data[0].configparam.globaldropoffpincode).length>0) {
            this.globaldropoffpincode= clientSettingData.globaldropoffpincode
          }
          if(clientSettingData.globaldropoffpincode.length!=0){
            this.initialDropPincodeoffEmpty=false
          this.finalGlobalDropoffPinode= clientSettingData.globaldropoffpincode
          }
        }
        if(clientSettingData.blockclientcode)
        {
          this.blockpickup = clientSettingData.blockclientcode.blockpickup == 1 ? true : false;
          this.blockdelivery = clientSettingData.blockclientcode.blockdelivery == 1 ? true : false;
          if (this.blockpickup || this.blockdelivery)  {
            this.blockclientreason = clientSettingData.blockclientcode.blockclientreason;
          }else{
            this.blockclientreason = ''
          }
        }
        if (clientSettingData.restrictserviceability) {
          this.pickupPincode = clientSettingData.restrictserviceability.pickuppincodes.join(','),
          this.deliveryPincode = clientSettingData.restrictserviceability.deliverypincodes.join(',')
          this.selectAllPickupPincodes = clientSettingData.restrictserviceability.allpickuppincodes == 1 ? true : false
          this.selectAllDeliveryPincodes = clientSettingData.restrictserviceability.alldeliverypincodes ? true : false
        }
			}
		} catch (error) {
			console.log(error);
			this.isLoading = false;
		}
	  },
	  closeClientDetails(){
		this.ShowClientDetails = false
		this.ShowAwbCopy = false
		this.ShowMpsCopy = false
    this.ShowClientDetailsforglobalpickup=false
    this.ShowGlobalPickup=false
    this.ShowGlobalDelivery=false
    this.ShowGlobalDropoff=false
    if(this.initialDataEmpty==false && this.pincode.length!=0){
    this.pincode=this.finalpincode
    }else{
      this.pincode=[]
    }
    if(this.initialDropPincodeoffEmpty==false && this.globaldropoffpincode.length!=0){
      this.globaldropoffpincode=this.finalGlobalDropoffPinode
      }else{
        this.globaldropoffpincode=[]
      }
	  },

	  async getAllClient(action){
		try {
			this.isLoading = true;
			this.clientlist=[]
			let inputPayload={}
			inputPayload.key = action
			let result = await AdminSettingsService.getAllKeyClient(inputPayload)
			this.isLoading = false;
			if(result.data.code == 200){
				result.data.data.map(obj=>{
					this.clientlist.push(obj.clientshortname)
				})
			}
			this.clinetnamelist = this.clientlist.toString().replaceAll(',' , ', ');
			this.ShowClientDetails = true
		} catch (error) {
			console.log(error);
			this.isLoading = false;
		}
	  },
	  async handler(action,event){
		try {
		  this.isLoading = true;
		  if(this.selectedClients.clientId){
			  this.isLoading = false;
			  if(action == 'awbcopy'){
				  this.printcopy = 'AWB Copy Customisation'
				  this.ShowAwbCopy = true
			  }else if(action == 'enableclient'){
          this.printcopy = 'Block Client Pickup/Delivery'
          this.blockclient = true
          if (!this.blockpickup && !this.blockdelivery) {
            this.blockclientreason = ''
          }
        }else if(action == 'restrictpincode'){
          this.ShowRestrictedPincodes = true
        }else if(action == 'disablePod'){
          this.disablepod = true
        }
        else{
				  this.printcopy = 'MPS Sticker Customisation'
				  this.ShowMpsCopy = true
			  }
		  }else{
			  this.isLoading = false;
			  this.$alertify.error("Please select client name")
		  }
		} catch (error) {
		  this.isLoading = false;
		}
	  },
	  saveAwbCopyData(){
		  try {
			  this.isLoading = true;
			  if(this.selectedClients.clientId){
				  if(this.bookinglabel1!='' && this.bookingfield1==''){
					  this.$alertify.error("Please enter Field1 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookinglabel1=='' && this.bookingfield1!=''){
					this.$alertify.error("Please enter Field1 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookinglabel2!='' && this.bookingfield2==''){
					  this.$alertify.error("Please enter Field2 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookinglabel2=='' && this.bookingfield2!=''){
					this.$alertify.error("Please enter Field2 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookinglabel3!='' && this.bookingfield3==''){
					  this.$alertify.error("Please enter Field3 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookinglabel3=='' && this.bookingfield3!=''){
					this.$alertify.error("Please enter Field3 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookinglabel1 == '' && this.bookingfield1==''){
					  this.selectedAwbCopy[0] = null
				  }else{
					  this.selectedAwbCopy[0] = {label:this.bookinglabel1,columnname:this.bookingfield1}
				  }
				  if(this.bookinglabel2 == '' && this.bookingfield2==''){
					  this.selectedAwbCopy[1] = null
				  }else{
					  this.selectedAwbCopy[1] = {label:this.bookinglabel2,columnname:this.bookingfield2}
				  }
				  if(this.bookinglabel3 == '' && this.bookingfield3==''){
					  this.selectedAwbCopy[2] = null
				  }else{
					  this.selectedAwbCopy[2] = {label:this.bookinglabel3,columnname:this.bookingfield3}
				  }
				  this.awblrcopydata={
					  ischecked:1,
					  field1: this.selectedAwbCopy[0],// null
					  field2: this.selectedAwbCopy[1],// null
					  field3: this.selectedAwbCopy[2] // null
				  }
				  if(this.selectedAwbCopy[0] == null && this.selectedAwbCopy[1]== null && this.selectedAwbCopy[2] == null){
					  this.awblrcopydata.ischecked = 0
				  }
				  this.isLoading = false;
				  this.saveClientSettings('clientmanagement','awblrcustomization');
				  this.$alertify.success("Data added Successfully");
				  this.ShowAwbCopy = false
			  }else{
				  this.isLoading = false;
				  this.$alertify.error("Please select client name")
			  }
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
	  setawbcopy(event,field){
		  try {
			  if(field == 'field1'){
				  this.updateLRDropdown(field,this.bookingfield1)
				  this.selectedAwbCopy[0] = {label:this.bookinglabel1,columnname:this.bookingfield1}
			  }
			  if(field == 'field2'){
				  this.updateLRDropdown(field,this.bookingfield2)
				  this.selectedAwbCopy[1] = {label:this.bookinglabel2,columnname:this.bookingfield2}
			  }
			  if(field == 'field3'){
				  this.updateLRDropdown(field,this.bookingfield3)
				  this.selectedAwbCopy[2] = {label:this.bookinglabel3,columnname:this.bookingfield3}
			  }
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
	  updateLRDropdown(field,selectedvalue){
		  try {
			  if(field == 'field1'){
				  this.bookingfieldlist2.forEach(item=>{
					  if(item.value == selectedvalue){
						item.disable = 1
					  }else if(item.value == this.bookingfield1){
						item.disable = 1
					  }else if(item.value == this.bookingfield3){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
				  this.bookingfieldlist3.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield1){
							item.disable = 1
					  }else if(item.value == this.bookingfield2){
						item.disable = 1;
					  }else{
						item.disable = 0;
					  }
				  })
			  }
			  if(field == 'field2'){
				  this.bookingfieldlist1.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield2){
						item.disable = 1
					  }else if(item.value == this.bookingfield3){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
				  this.bookingfieldlist3.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield1){
						item.disable = 1
					  }else if(item.value == this.bookingfield2){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
			  }

			  if(field == 'field3'){
				  this.bookingfieldlist1.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield2){
						item.disable = 1
					  }else if(item.value == this.bookingfield3){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
				  this.bookingfieldlist2.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else if(item.value == this.bookingfield1){
						item.disable = 1
					  }else if(item.value == this.bookingfield3){
						item.disable = 1
					  }else{
						item.disable = 0;
					  }
				  })
			  }
		  } catch (error) {
			  console.log(error)
		  }
	  },
	  updateMpsStickerDropdown(field,selectedvalue){
		  try {
			  if(field == 'field1'){
				  this.mpsfieldlist2.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else{
						  item.disable = 0
					  }
				  })
			  }
			  if(field == 'field2'){
				  this.mpsfieldlist1.forEach(item=>{
					  if(item.value == selectedvalue){
						  item.disable = 1
					  }else{
						  item.disable = 0
					  }
				  })
			  }
		  } catch (error) {
			  console.log(error)
		  }
	  },
	  saveMpsStickerData(){
		  try {
			  this.isLoading = true;
			  if(this.selectedClients.clientId){
				  if(this.bookingmpslabel1!='' && this.bookingmpsfield1==''){
					  this.$alertify.error("Please enter Field1 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookingmpslabel1=='' && this.bookingmpsfield1!=''){
					this.$alertify.error("Please enter Field1 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookingmpslabel2!='' && this.bookingmpsfield2==''){
					  this.$alertify.error("Please enter Field2 Value");
					  this.isLoading = false;
					  return false;
				  }else if(this.bookingmpslabel2=='' && this.bookingmpsfield2!=''){
					this.$alertify.error("Please enter Field2 Label");
					this.isLoading = false;
					return false;
				  }
				  if(this.bookingmpslabel1 == '' && this.bookingmpsfield1==''){
					  this.selectedMpsCopy[0] = null
				  }else{
					  this.selectedMpsCopy[0] = {label:this.bookingmpslabel1,columnname:this.bookingmpsfield1}
				  }
				  if(this.bookingmpslabel2 == '' && this.bookingmpsfield2==''){
					  this.selectedMpsCopy[1] = null
				  }else{
					  this.selectedMpsCopy[1] = {label:this.bookingmpslabel2,columnname:this.bookingmpsfield2}
				  }
				  this.mpsstickerdata={
					  ischecked:1,
					  field1: this.selectedMpsCopy[0],// null
					  field2: this.selectedMpsCopy[1],// null
				  }
				  if(this.selectedMpsCopy[0] == null && this.selectedMpsCopy[1]== null){
					  this.mpsstickerdata.ischecked = 0
				  }
				  this.isLoading = false;
				  this.saveClientSettings('clientmanagement','mpsstickerdata');
				  this.$alertify.success("Data added Successfully");
				  this.ShowMpsCopy = false
			  }else{
				  this.isLoading = false;
				  this.$alertify.error("Please select client name")
			  }
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error)
		  }

	  },
	  setmpscopy(event,field){
		  try {
			  if(field == 'field1'){
				  this.updateMpsStickerDropdown(field,this.bookingmpsfield1)
				  this.selectedMpsCopy[0] = {label:this.bookingmpslabel1,columnname:this.bookingmpsfield1}
			  }
			  if(field == 'field2'){
				  this.updateMpsStickerDropdown(field,this.bookingmpsfield2)
				  this.selectedMpsCopy[1] = {label:this.bookingmpslabel2,columnname:this.bookingmpsfield2}
			  }
		  } catch (error) {
			  console.log(error);
		  }
	  },
	  resetAWBCopy(){
		  try {
			  this.bookinglabel1 = ""
			  this.bookingfield1 = ""
			  this.bookinglabel2 = ""
			  this.bookingfield2 = ""
			  this.bookinglabel3 = ""
			  this.bookingfield3 = ""
			  this.bookingfieldlist1.forEach(item=>{
				item.disable = 0;
			  })
			  this.bookingfieldlist2.forEach(item=>{
				item.disable = 0;
			  })
			  this.bookingfieldlist3.forEach(item=>{
				item.disable = 0;
			  })
			  this.selectedAwbCopy[0] = null
			  this.selectedAwbCopy[1] = null
			  this.selectedAwbCopy[2] = null
		  } catch (error) {
			  console.log(error)
		  }
	  },
	  resetMPSCopy(){
		  try {
			  this.bookingmpslabel1 = ""
			  this.bookingmpsfield1 = ""
			  this.bookingmpslabel2 = ""
			  this.bookingmpsfield2 = ""
			  this.mpsfieldlist1.forEach(item=>{
				item.disable = 0;
			  })
			  this.mpsfieldlist2.forEach(item=>{
				item.disable = 0;
			  })
			  this.selectedMpsCopy[0] = null
			  this.selectedMpsCopy[1] = null
		  } catch (error) {
			  console.log(error)
		  }
	  },
    saveGlobalPickupData(){
		  try {
			  this.isLoading = true;
			  if(this.selectedClients.clientId){
          if(typeof(this.pincode) === 'string')
          {
            this.globalpickuppincodedataArray=this.pincode.split(",")
            if( this.globalpickuppincodedataArray.length>0)
            {
              var pincodeArray = this.globalpickuppincodedataArray.map(str => parseInt(str, 10));
              this.pincode=this.isArrayEqualNaN(pincodeArray)?[]:pincodeArray
            }
          }
				  this.isLoading = false;
				   this.saveClientSettings('clientmanagement','enableglobalpickup');
          this.ShowGlobalPickup=false
			  }else{
				  this.isLoading = false;
				  this.$alertify.error("Please select client name")
			  }
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
    saveGlobalDeliveryData(){
		  try {
			  this.isLoading = true;
			  if(this.selectedClients.clientId){
          if(typeof(this.globaldeliverypincode) === 'string')
          {
            this.globalpickuppincodedataArray=this.globaldeliverypincode.split(",")
            if( this.globalpickuppincodedataArray.length>0)
            {
              var pincodeArray = this.globalpickuppincodedataArray.map(str => parseInt(str, 10));
              this.globaldeliverypincode=this.isArrayEqualNaN(pincodeArray)?[]:pincodeArray
            }
          }
				  this.isLoading = false;
				  this.saveClientSettings();
				  this.ShowAwbCopy = false
			  }else{
				  this.isLoading = false;
				  this.$alertify.error("Please select client name")
			  }
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
    isArrayEqualNaN(arr) {
      if (!Array.isArray(arr)) {
        return false; // Not an array
      }
      if (arr.length !== 1) {
        return false; // Array length is not 1
      }
      return isNaN(arr[0]);
    },
    resetGlobalPickup(action)
    {
      if(action=='globalpickup') {
     this.pincode=[]
      }if(action=='globaldeliver') {
      this.globaldeliverypincode=[]
      } else {
        this.globaldeliverypincode=[]
        this.pincode=[]
      }
    },
    async GlobalPickupPincode(action,event){
      try {
        this.isLoading = true;
        if(this.selectedClients.clientId && action=='pincode' ){
            this.isLoading = false;
            this.ShowGlobalPickup = true
        } else if(this.selectedClients.clientId  && action=='globaldeliverypincode' ){
          this.isLoading = false;
          this.ShowGlobalDelivery = true
        }else if(this.selectedClients.clientId  && action=='globaldropoffpincode' ){
          this.isLoading = false;
          this.ShowGlobalDropoff = true
        }else{
          this.isLoading = false;
          this.$alertify.error("Please select client name")
        }
      } catch (error) {
        this.isLoading = false;
      }
      },
    async getAllClientforGlobalPickup(action){
      try {
        this.isLoading = true;
        this.clientlist=[]
        this.GlobalPickupViewData={}
        let inputPayload={}
        inputPayload.key = action
        let result = await AdminSettingsService.getAllKeyClient(inputPayload)
        this.isLoading = false;
        if(result.data.code == 200){
          this.GlobalPickupClientPincodeData=result.data.data
        }
        else{
          this.GlobalPickupClientPincodeData={clientname:null,pincode:[]}
        }
        this.clinetnamelist = this.clientlist.toString().replaceAll(',' , ', ');
        this.ShowClientDetailsforglobalpickup = true
      } catch (error) {
        this.isLoading = false;
      }
      },
      saveBlockClientCodeData(){
        try {
          this.isLoading = true;
          if(this.selectedClients.clientId){
            if(this.blockclientreason==''){
              this.$alertify.error("Please enter resason");
              this.isLoading = false;
              return false;
            }
            if (this.blockpickup || this.blockdelivery) {
              this.blockclientcode = {
                blockpickup : this.blockpickup ? 1 : 0,
                blockdelivery : this.blockdelivery ? 1 : 0,
                blockclientreason : this.blockclientreason,
                ischecked : 1
              }
            }else{
              this.blockclientcode = {}
            }
            this.isLoading = false;
            this.saveClientSettings('clientmanagement','blockpickupdelivery');
            this.$alertify.success("Data added Successfully");
            this.blockclient = false
          }else{
            this.isLoading = false;
            this.$alertify.error("Please select client name")
          }
        } catch (error) {
          this.isLoading = false;
          console.log(error);
        }
      },
      resetBlockClientCodeData(){
        try {
          this.blockpickup = 0 ;
          this.blockdelivery = 0 ;
          this.blockclientreason="" ;
          this.blockclientcode = {}
        } catch (error) {
          console.log(error)
        }
      },
      resetPodDisable(disableflag){
        if (!disableflag) {
          this.DisabledProofOfDelivery = false
        }
        this.isreuploadpodrequired = false
        this.PODPincode = null;
        this.selectedConsignee = null;
        this.selectAllConsignee = false;
        this.consigneeList = [];
        this.podConfig = []
        this.$validator.reset()
      },
      saveGlobalDropoffData() {
        try {
          this.isLoading = true;
          if (this.selectedClients.clientId) {
            if (typeof (this.globaldropoffpincode) === 'string') {
              this.globaldropoffpincodedataArray = this.globaldropoffpincode.split(",")
              if (this.globaldropoffpincodedataArray.length > 0) {
              if(this.globaldropoffpincodedataArray[0]=='ALL'){
                this.globaldropoffpincode = ['ALL']
              }else{
                var pincodeArray = this.globaldropoffpincodedataArray.map(str => parseInt(str, 10));
                this.globaldropoffpincode = this.isArrayEqualNaN(pincodeArray) ? [] : pincodeArray
              }
              }
            }
            this.isLoading = false;
            this.saveClientSettings();
          this.ShowGlobalDropoff = false
          } else {
            this.isLoading = false;
            this.$alertify.error("Please select client name")
          }
        } catch (error) {
          this.isLoading = false;
          console.log(error);
        }
      },
      resetGlobalDropoff()
      {
       this.globaldropoffpincode=[]
      },
      saveRestrictedPincodes(){
        try {
          this.isLoading = true;
          if(this.selectedClients.clientId){
            if(typeof(this.pickupPincode) === 'string')
            {
              this.pickupPincodedataArray=this.pickupPincode.split(",")
              if( this.pickupPincodedataArray.length>0)
              {
                var pickupPincodeArray = this.pickupPincodedataArray.map(str => parseInt(str, 10));
                this.pickupPincode=this.isArrayEqualNaN(pickupPincodeArray)?[]:pickupPincodeArray
              }
            }
            if(typeof(this.deliveryPincode) === 'string')
            {
              this.deliveryPincodedataArray=this.deliveryPincode.split(",")
              if( this.deliveryPincodedataArray.length>0)
              {
                var deliveryPincodeArray = this.deliveryPincodedataArray.map(str => parseInt(str, 10));
                this.deliveryPincode=this.isArrayEqualNaN(deliveryPincodeArray)?[]:deliveryPincodeArray
              }
            }
            this.isLoading = false;
            this.saveClientSettings();
            this.ShowRestrictedPincodes = false
          }else{
            this.isLoading = false;
            this.$alertify.error("Please select client name")
          }
        } catch (error) {
          this.isLoading = false;
          console.log(error);
        }
      },
      selectAllDeliveryPincodesFunction(){
        this.deliveryPincode = "";
      },
      selectAllPickupPincodesFunction(){
        this.pickupPincode = "";
      },
      resetRestrictedPincodes(){
        this.pickupPincode = "";
        this.deliveryPincode = "";
        this.selectAllPickupPincodes = false;
        this.selectAllDeliveryPincodes = false;
      },
      isIntegerOnlty: function(evt) {
        this.consigneeList = []
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode < 48 || charCode > 57) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
  },
}
Validator.extend('verify_pincode', {
  getMessage: field => "The Pincode field format is invalid",
  validate: value => {
  if ( value.match(/^\d{6}(,\d{6})*$/)) {
    this.disablesave=false
    return true
  }else{
    this.disablesave=true
    return false;
  }
  }
});
Validator.extend('verify_deliverypincode', {
  getMessage: field => "The Pincode field format is invalid",
  validate: value => {
    if (value.match(/^\d{6}(,\d{6})*$/)) {
      this.disablesave = false
      return true
    } else {
      this.disablesave = true
      return false;
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/configuration/clientManagement/clientmanagementconfiguration.component.js